// extracted by mini-css-extract-plugin
export var boxItems = "_26-1";
export var boxItemsLg = "_26-2";
export var button = "_26-7";
export var buttonHoverless = "_26-9";
export var buttonLg = "_26-8";
export var filterGroupBox = "_26-0";
export var icon = "_26-3";
export var iconSecondary = "_26-6";
export var iconWrapper = "_26-4";
export var iconWrapperLg = "_26-5";
export var truncatedLabel = "_26-a";